import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { UserModel } from "../../models/user/user.model";
import { Configurations } from "../../core/configurations";
import { UltimaVersioneApplicativoClientService } from "../../services/ultima-versione-applicativo-client.service";
import { NavigationEnd, Router } from "@angular/router";
declare var $: any;

@Component({
  selector: "private-layout-component",
  moduleId: module.id,
  templateUrl: "private-layout.component.html",
  styleUrls: ['./private-layout.component.css', '../../../assets/css/AngularAgentiWebPrivateCommon.css']

})
export class PrivateLayoutComponent implements OnInit {
  model: UserModel = null;
  codVersioneImg: string;
  pathImmagini: string = Configurations.baseUrl + "assets/imgs";
  isTest: boolean = Configurations.published ? false : true;
  constructor(private accountService: AuthService, private _ultimaVersioneClientTipo: UltimaVersioneApplicativoClientService, private router: Router) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (this.isMobile()) {
          $('.sidebar-mini').toggleClass('sidebar-open');
        }

      }
    });
  }

  ngOnInit() {
    this.model = this.accountService.user;
    this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
      .subscribe(data => {
        Configurations.currentVersionCod = data.codice;
        let v = localStorage.getItem('clientVersion');
        if (v === null || v === undefined || v !== data.codice) {
          localStorage.setItem('clientVersion', data.codice);
          alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
          window.location.href = Configurations.baseUrl;

        }
      });
  }

  isMobile() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];
    return (toMatch.map((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    })
    ).find((item) => !!item);
  }

  logout() {
    this.accountService.logout(true);
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/layout/private-layout.component.ts